import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;

const SEARCH = `${API_URL}/invoices/company/:company/search`;
const GET_ALL = `${API_URL}/invoices/all/:company`;
const GET_STATUS_ACCOUNT_CSV = `${API_URL}/:customer/invoices/all-by-company/:company`;

export default {
  async search(company, filters, page, size, isRep = false) {
    if (!isRep) isRep = null;
    const properties = {
      method: 'GET',
      params: { company },
      query: {
        ...filters,
        page,
        size,
        voucherType: 'I',
        isRep,
      },
    };

    const response = await customFetch(SEARCH, properties);

    const { payload } = await response.json();
    return payload;
  },

  async getAllCsv(company) {
    const response = await customFetch(GET_ALL, {
      method: 'GET',
      params: { company },
    });
    const payload = await response.blob();
    return payload;
  },
  async getStatusAccountCsv(company, customer) {
    const response = await customFetch(GET_STATUS_ACCOUNT_CSV, {
      method: 'GET',
      params: { customer, company },
    });
    const payload = await response.blob();
    return payload;
  },
};
